module.exports = __webpack_public_path__ + "static/img/bg_10.4e84369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_10.jpg
// module id = xe8S
// module chunks = 1